import { useState } from "react";
import { useDispatch } from "react-redux";
import { logoutData } from "../features/auth/logout/logoutSlice";
import { OK } from "../constants/statusCode";
import documentImg from "../assets/images/document-text.svg";
import plusicnImg from "../assets/images/plusicn.svg";
import logoutImg from "../assets/images/logout.svg";
import { clearSession } from "../utils/localSession";
import { useNavigate } from "react-router-dom";
import SwitchProjectModal from "../components/projectComponent/SwitchProjectModal";
import { resetConversation } from "../features/chatbot/getParticularConversationSlice";
import { cancelSendQuestionData } from "../services/chatbot/api";

const HeaderChatBox = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [currentModal, setCurrentModal] = useState("");

  const handleLogout = async () => {
    const { payload } = await dispatch(logoutData());
    if (payload.status === OK) {
      clearSession();
      navigate("/login");
    }
  };

  const SwitchProjectToggle = () => {
    setCurrentModal("");
  };

  return (
    <>
      <header className="header header-chat">
        <div className="row align-items-center justify-content-between header-row">
          <div className="col-6 col-sm-5 col-md-6 col-lg-6 col-xl-5 col-xxl-4">
            <div className="d-flex align-items-center">
              {JSON.parse(localStorage.getItem("_user")).projects[0]
                .website_logo && (
                <span className="edit-svgicn-btn cursor-pointer">
                  <img
                    height="22px"
                    width="22px"
                    src={`${process.env.REACT_APP_CLOUD_FRONT_URL}projects/${
                      JSON.parse(localStorage.getItem("_user")).projects[0].uuid
                    }/${
                      JSON.parse(localStorage.getItem("_user")).projects[0]
                        .website_logo
                    }`}
                    alt="website logo"
                    className="edit-svgicn"
                  />
                </span>
              )}
              <h1 className="header-title header-input-title">
                {JSON.parse(localStorage.getItem("_user")).projects[0].name}
              </h1>
            </div>
          </div>
          <div className="col-6 col-sm-7 col-md-6 col-lg-6 col-xl-7 col-xxl-8 text-end">
            <div className="d-flex justify-content-end header-right-btngrup align-items-center">
              <button
                className="btn btn-primary create-doc-btn mt-0 btn-primary-md"
                onClick={() => {
                  cancelSendQuestionData();
                  dispatch(resetConversation());
                  navigate("/dashboard");
                }}
              >
                <img src={documentImg} alt="" className="chat-btn-icon" />{" "}
                Content
              </button>

              {/* <div className="btn-group notify-dropdown">
                <button
                  type="button"
                  className="btn btn-secondary dropdown-toggle"
                  // data-bs-toggle="dropdown"
                  // aria-expanded="false"
                >
                  <img className="notify-icn" src={notifyicn} alt="ejimg" />
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <div className="notifymenu-header">
                    <p>Notifications</p>
                  </div>
                  <div className="notifymenu-body">
                    <span
                      className="nonot-found-txt"
                      style={{ display: "none" }}
                    >
                      No new Notifications found
                    </span>
                    <ul className="notification-list custom-scrollbar text-start">
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                    </ul>
                  </div>
                  <div className="notifymenu-footer">
                    <button type="button" className="btn">
                      View all notifications
                    </button>
                  </div>
                </ul>
              </div> */}
              <div className="user-menu mt-1 me-0">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle pe-none"
                    type="button"
                  >
                    <div className="user-profile-text">
                      {`${
                        JSON.parse(localStorage.getItem("_user")).first_name
                      } ${JSON.parse(localStorage.getItem("_user")).last_name}`
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()}
                    </div>
                    {/* <img src={ejImg} alt="ej_img" /> */}
                    <div className="user-drop-title chatbot-drop-title">
                      <p>
                        {JSON.parse(localStorage.getItem("_user")).first_name}{" "}
                        {JSON.parse(localStorage.getItem("_user")).last_name}
                      </p>
                      <span>
                        {
                          JSON.parse(localStorage.getItem("_user")).projects[0]
                            .name
                        }
                      </span>
                    </div>
                  </button>
                  {/* <ul
                    className="dropdown-menu"
                    data-popper-placement="top-start"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setCurrentModal("switchModal")}
                      >
                        <img
                          className="dropdown-item-img"
                          src={plusicnImg}
                          alt="plusicn"
                        />
                        Switch Project
                      </a>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleLogout()}
                      >
                        <img
                          className="dropdown-item-img"
                          src={logoutImg}
                          alt="logout"
                        />
                        Logout
                      </button>
                    </li>
                  </ul> */}
                </div>
              </div>
              {/* <button className="btn btn-primary-md">+ New category</button> */}
            </div>
          </div>
          <SwitchProjectModal
            isOpen={currentModal === "switchModal"}
            toggle={SwitchProjectToggle}
            title={"Switch Project"}
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
            isChatPage={true}
          />
        </div>
      </header>
    </>
  );
};

export default HeaderChatBox;
